import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapGetters, mapActions } from "vuex";
import * as types from "@survey/store/types";
import * as dateUtil from "@appbase/util/date-helper";
import SurveyTargetContainer from "@survey/components/SurveyWriteS1/SurveyTargetContainer.vue";
import SurveyApproverContainer from "@survey/components/SurveyWriteS1/SurveyApproverContainer.vue";
import DatePicker from "@appbase/components/DatePicker/DatePicker.vue";
import FileUploder from "@appbase/components/common/FlowFileUploader/FlowFileUploader.vue";
import { invalidateUrl } from "@appbase/util/invalidate-url";
import { FlowFileMeta } from "@appbase/components/common/FlowFileUploader/flow-file-meta";
import api from "@survey/api";
import * as accountTypes from "@account/store/types";

import appBaseApi from "@appbase/api";
import flowHelper from "@appbase/components/common/FlowFileUploader/flow-helper";

@Component({
    components: {
        DatePicker,
        SurveyTargetContainer,
        SurveyApproverContainer,
        FileUploder,
    },
    methods: {
        ...mapActions({
            setSurveyId: types.SURVEY_CREATED_SURVEYID,
        }),
    },
    computed: {
        ...mapGetters({
            user: accountTypes.USER,
            createdSurveyId: types.SURVEY_CREATED_SURVEYID,
        }),
    },
})
export default class SurveyWriteS1Grid extends Vue {
    setSurveyId!: (surveyId: number) => void;
    createdSurveyId!: number;
    user!: account.User;

    surveyRequest: survey.SurveyRequest = Object.create(null);

    // title : string = ""
    // isTargetAll : number = 0
    // targets : Array<any> = []
    // isAnonymous : boolean = false
    // isPublic : boolean = false

    //바로게시 옵션
    nowPosting: boolean = false;
    showNowPostingBtn: boolean = false; //비활성으로 수정
    isTargetAll: number = 1;

    //데이트피커 시작, 종료
    startDate: string = "";
    endDate: string = "";

    //데이트피커 시작, 종료
    resultStartDate: string = "";
    resultEndDate: string = "";

    //fileUploder
    codeValues: Array<string> = ["SURVEY", "MAIN"]; // 파일코드는 고정임
    fileMetaInfo: FlowFileMeta = Object.create(null);
    files: any[] = [];
    uploadUrl: string = "";
    deleteUrl: string = "";

    //show target container
    showContainer: boolean = false;
    containerTargets: survey.SurveyTargets[] = [];
    containerApprovers: Array<any> = [];

    isReady: boolean = false;

    //fileSelectAll toggle
    // selectAllToggle : boolean = false

    async created() {
        //surveyRequest 초기 데이터
        await this.initData();
        //시작, 종료일 초기화
        this.initDate();
        //upload 초기화
        this.initFileUploader();

        this.isReady = true;
    }

    async initData() {
        let querySurveyId = parseInt(this.$route.query.surveyId as string);
        let isEmptySurveyID = typeof this.createdSurveyId;

        //신규 생성 case
        if (isEmptySurveyID == "object" && isNaN(querySurveyId)) {
            this.surveyRequest.mainInfo = {
                title: "",
                description: "",
                isTargetAll: true,
                isAnonymous: false,
                isPublic: false,
                status: 1, // 최초 상태 대기,
            } as survey.SurveyMainInfo;
        } else {
            //생성된 설문이 있는 경우
            let surveyId = isEmptySurveyID == "object" ? querySurveyId : this.createdSurveyId;

            await api.survey.getSurveyById(surveyId).then(async (result) => {
                if (result.mainInfo != null) {
                    //store 에 surveyId 저장
                    this.setSurveyId(result.mainInfo.surveyId as number);

                    //데이터 초기화 진행
                    //MainInfo
                    let mainInfo = result.mainInfo;

                    this.isTargetAll = mainInfo.isTargetAll;
                    this.surveyRequest.mainInfo = {
                        surveyId: mainInfo.surveyId,
                        title: mainInfo.title,
                        description: mainInfo.description,
                        isTargetAll: mainInfo.isTargetAll,
                        isAnonymous: mainInfo.isAnonymous,
                        isPublic: mainInfo.isPublic,
                        status: mainInfo.status, // 최초 상태 대기,
                        fileCode: mainInfo.fileCode,
                        startDate: mainInfo.startDate,
                        endDate: mainInfo.endDate,
                        resultStartDate: mainInfo.resultStartDate,
                        resultEndDate: mainInfo.resultEndDate,
                    } as survey.SurveyMainInfo;

                    //바로게시 버튼은 현재 상태가 진행중이면 표시하지 않는다
                    if (mainInfo.status == 2) {
                        this.showNowPostingBtn = false;
                    }

                    console.log("resultTargets", result.targets);

                    //targets
                    //컨테이너 정보
                    this.surveyRequest.targets = result.targets;
                    this.containerTargets = result.targets || [];
                    this.surveyRequest.approvers = result.approvers;
                    this.containerApprovers = (result.approvers as Array<any>).map((item) => {
                        return {
                            identityCode: item.identityCode,
                            id: item.identityCode,
                            personCode: item.identityCode,
                            name: item.displayName,
                            deptName: item.deptName || "",
                            isDepartment: item.isDepartment,
                        };
                    });

                    //여기서 파일 정보 초기화
                    //파일코드가 있는 경우 목록 초기화
                    let fileCode = result.mainInfo.fileCode;
                    if (fileCode != "") {
                        appBaseApi.file.getFiles(fileCode).then((result) => {
                            this.files = result.map((item) =>
                                flowHelper.convertToFlowFile({
                                    ...item,
                                    uniqueIdentifier: item.id,
                                    type: "Database",
                                })
                            );
                        });
                    }

                    this.onChangedSurveyRequest();
                } else {
                    // maininfo 가 null 인 경우는 없는 정보 조회 잘못된 접금
                    //리스트 화면으로 redirect
                    await (window as any).alertAsync(this.$t("잘못된_접근입니다").toString());
                    this.$router.push({
                        name: "SurveyList",
                    });
                }
            });
        }
    }

    initFileUploader() {
        this.uploadUrl = invalidateUrl("/cm/file/store/flow");
        this.deleteUrl = invalidateUrl("/cm/file/store/delete");
        let fileCode = this.surveyRequest.mainInfo.fileCode;

        this.fileMetaInfo = {
            code: fileCode || this.generateAttachmentCode(),
            codeValues: this.codeValues,
            type: "file",
        };
        this.surveyRequest.mainInfo.fileCode = this.fileMetaInfo.code;
    }

    initDate() {
        var request = this.surveyRequest.mainInfo;
        if (request.startDate == null || request.resultStartDate == null) {
            let now = new Date();
            let endDate = new Date();
            new Date(endDate.setDate(endDate.getDate() + 7));

            this.startDate = dateUtil.uGetDateFormat("yyyy-MM-DD", now);
            this.endDate = dateUtil.uGetDateFormat("yyyy-MM-DD", endDate);
            this.resultStartDate = dateUtil.uGetDateFormat("yyyy-MM-DD", now);
            this.resultEndDate = dateUtil.uGetDateFormat("yyyy-MM-DD", endDate);
            //surveyMainInfo
            this.surveyRequest.mainInfo.startDate = now;
            this.surveyRequest.mainInfo.endDate = endDate;
            this.surveyRequest.mainInfo.resultStartDate = now;
            this.surveyRequest.mainInfo.resultEndDate = endDate;
        } else {
            this.startDate = dateUtil.uGetDateFormat("yyyy-MM-DD", new Date(this.surveyRequest.mainInfo.startDate));
            this.endDate = dateUtil.uGetDateFormat("yyyy-MM-DD", new Date(this.surveyRequest.mainInfo.endDate));
            this.resultStartDate = dateUtil.uGetDateFormat("yyyy-MM-DD", new Date(this.surveyRequest.mainInfo.resultStartDate));
            this.resultEndDate = dateUtil.uGetDateFormat("yyyy-MM-DD", new Date(this.surveyRequest.mainInfo.resultEndDate));
        }
    }

    updateStartDate(date: Date) {
        // console.log(`updateType : ${updateType}`)
        if (!this.checkStartDatepickerValidate(date) || !this.checkDatepickerValidate(date, new Date(this.endDate))) {
            this.$nextTick(() => {
                this.startDate = dateUtil.uGetDateFormat("yyyy-MM-DD", new Date());
                this.surveyRequest.mainInfo.startDate = new Date();
            });
            return;
        }
        this.startDate = dateUtil.uGetDateFormat("yyyy-MM-DD", date);
        this.surveyRequest.mainInfo.startDate = date;
        this.onChangedSurveyRequest();
    }

    updateEndDate(date: Date) {
        if (!this.checkStartDatepickerValidate(date) || !this.checkDatepickerValidate(new Date(this.startDate), date)) {
            this.$nextTick(() => {
                this.endDate = dateUtil.uGetDateFormat("yyyy-MM-DD", new Date(new Date(this.startDate)));
                this.surveyRequest.mainInfo.endDate = new Date(new Date(this.startDate));
            });
            return;
        }
        this.endDate = dateUtil.uGetDateFormat("yyyy-MM-DD", date);
        this.surveyRequest.mainInfo.endDate = date;
        this.onChangedSurveyRequest();
    }

    updateResultStartDate(date: Date) {
        if (!this.checkStartDatepickerValidate(date) || !this.checkDatepickerValidate(date, new Date(this.resultEndDate))) {
            this.$nextTick(() => {
                this.resultStartDate = dateUtil.uGetDateFormat("yyyy-MM-DD", new Date());
                this.surveyRequest.mainInfo.resultStartDate = new Date();
            });
            return;
        }
        this.resultStartDate = dateUtil.uGetDateFormat("yyyy-MM-DD", date);
        this.surveyRequest.mainInfo.resultStartDate = date;
        this.onChangedSurveyRequest();
    }

    updateResultEndDate(date: Date) {
        if (!this.checkStartDatepickerValidate(date) || !this.checkDatepickerValidate(new Date(this.resultStartDate), date)) {
            this.$nextTick(() => {
                this.resultEndDate = dateUtil.uGetDateFormat("yyyy-MM-DD", new Date(new Date(this.resultStartDate)));
                this.surveyRequest.mainInfo.resultEndDate = new Date(new Date(this.resultStartDate));
            });
            return;
        }
        this.resultEndDate = dateUtil.uGetDateFormat("yyyy-MM-DD", date);
        this.surveyRequest.mainInfo.resultEndDate = date;
        this.onChangedSurveyRequest();
    }

    updateTargetUsers(users: Array<survey.SurveyTargets>) {
        var newTargets = [...this.containerTargets];

        users.forEach((u) => {
            if (!(newTargets.findIndex((n) => n.identityCode === u.identityCode) >= 0)) {
                newTargets.push(u);
            }
        });

        this.containerTargets = newTargets;
        this.surveyRequest.targets = newTargets;
        this.onChangedSurveyRequest();
    }

    deleteTargetUser(identityCode: string) {
        let deleted = this.containerTargets.filter((item) => {
            return item.identityCode != identityCode;
        });

        this.surveyRequest.targets = deleted;
        this.containerTargets = deleted;
        this.onChangedSurveyRequest();
    }

    deleteAllTargetUsers() {
        this.containerTargets = [];
        this.surveyRequest.targets = [];
    }

    updateApproverUsers(users: Array<survey.SurveyApprovers>) {
        this.containerApprovers = users;
        this.surveyRequest.approvers = users;
        this.onChangedSurveyRequest();
    }

    deleteApproverUser(personCode: string) {
        let filteredData = this.containerApprovers.filter((item) => {
            return item.personCode != personCode;
        });
        this.surveyRequest.approvers = filteredData;
        this.containerApprovers = filteredData;
        this.onChangedSurveyRequest();
    }

    deleteAttachment(fileIdentifier: string) {
        const codeValues = this.codeValues;
        const code = <string>this.surveyRequest.mainInfo.fileCode;

        appBaseApi.file.deleteFiles(code, codeValues, [""], [fileIdentifier]).then(() => {
            this.files = this.files.filter((file) => {
                return file.serverPath != fileIdentifier;
            });
        });
    }

    //fileCode 생성
    generateAttachmentCode() {
        const tag = "SURVEY_MAIN";
        const uid = `UID${Date.now()}`;
        const code = `${tag}_${uid}`;
        return code;
    }

    //update surveyRequest Info
    // @Watch("surveyRequest.mainInfo.title")
    onChangedSurveyRequest() {
        this.surveyRequest.mainInfo.isTargetAll = this.isTargetAll;
        this.showContainer = this.isTargetAll == 0;

        let isStatusEdit = false;
        //바로게시 옵션 적용 신규생성일 때 만 X
        if (!this.surveyRequest.mainInfo.surveyId) {
            isStatusEdit = true;
        } else if (this.surveyRequest.mainInfo.surveyId && this.surveyRequest.mainInfo.status == 1) {
            isStatusEdit = true;
            //들어오는 조건
        }

        if (isStatusEdit) {
            this.surveyRequest.mainInfo.status = this.nowPosting ? 2 : 1;
        }

        this.$emit("update", this.surveyRequest);
    }

    // 시작일, 종료일 비교
    async checkDatepickerValidate(startDate: Date, endDate: Date): Promise<boolean> {
        var startTime = dateUtil.IEDate(startDate);
        var endTime = dateUtil.IEDate(endDate);

        if (startTime.getTime() > endTime.getTime()) {
            debugger;
            await (window as any).alertAsync(this.$t("시간선택_오류"));
            return false;
        } else {
            return true;
        }
    }
    // 시작일, 현재 비교
    async checkStartDatepickerValidate(startDate: Date): Promise<boolean> {
        var startTime = dateUtil.IEDate(startDate);
        var today = dateUtil.IEDate(new Date().setHours(0, 0, 0, 0));

        if (startTime.getTime() < today.getTime()) {
            await (window as any).alertAsync("선택일이 현재보다 이전입니다.");
            return false;
        } else {
            return true;
        }
    }
}
